// Core React Imports
import React from "react";

// Local Imports
import { Input } from "../../../styles/SharedStyles";
import { useCustomValidation } from "../../../utils/useCustomValidation";

const WidgetInputBase = ({ value, onChange, required = true, ...otherProps }) => {
  const validationProps = useCustomValidation();

  return (
    <Input
      {...validationProps}
      value={value}
      onChange={(e) => {
        validationProps.onChange?.(e);
        onChange?.(e);
      }}
      required={required}
      {...otherProps}
    />
  );
};

export default WidgetInputBase;
